export const CLIENT_ID = 'ae520a706c27417f8b6b44bc41c224d0';
export const CLIENT_PUBLIC = '2fecacd1974f4b9aacc3bafb76e8aeda';
